import React, { useState } from 'react';
import { usePost } from "../../api/reactQueryCustomHooks";
import { linksUrl, apiRoute } from "../../constants/enum";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MainContainer } from '../../components';

const GSTReportForm = () => {
  const { compCode } = useSelector((state) => state.company);
  const navigate = useNavigate();

  // All options data
  const reportTypes = [
    "GST Ledger",
    "GST Summary Periodwise Report",
    "GST Register",
    "GST Register (Outward) for Refund Process",
    "GST Register (Inward) for Refund Process",
    "Cross Check Ledger",
    "Trading Register",
    "Reverse Chargable Inward Supply",
    "Accountwise Tax % Summary",
    "Statewise Tax % Summary",
    "GST Error Check",
    "GSTR 1 Report",
    "GSTR 2 Report",
    "GSTR 3B Report",
    "GSTR 9 Report",
    "GSTR ITC-04 Report",
    "HSN SUMMARY",
    "Cross Check Data GST2B"
  ];

  const tradeTypes = ["ALL", "RD", "URD", "OGS"];
  const billTypes = [
    { value: "ALL", label: "ALL" },
    { value: "P", label: "PURCHASE" },
    { value: "T", label: "SALE RETURN" },
    { value: "J", label: "JOB EXPENSE" },
    { value: "S", label: "SALE" },
    { value: "N", label: "PURCHASE RETURN" },
    { value: "I", label: "JOB INCOME" },
    { value: "VD", label: "DEBIT NOTE" },
    { value: "VC", label: "CREDIT NOTE" }
  ];
  const supplyTypes = ["ALL", "Outward", "Inward"];
  const reverseCharges = ["ALL", "NO Reverse Charge", "Reverse Charge"];
  const gstTypes = ["ALL", "GST Registered", "GST UnRegistered"];
  const goodsNatures = [
    "ALL",
    "Taxable",
    "Exempted",
    "Nil Rated",
    "Zero Rated",
    "Non GST"
  ];

  // Form state
  const [formData, setFormData] = useState({
    reportType: '',
    tradeType: '',
    billType: '',
    supplyType: '',
    reverseCharge: 'ALL',
    gstType: '',
    goodsNature: '',
    partyCode: '',
    fromDate: '',
    toDate: '',
    voucherType: '',
    tradeOf: '',
    accountCode: '',
    state: ''
  });

  const { mutate: generateGSTReport, isPending: isGstLedgerPending } = usePost({
    url: apiRoute.gstReport.getGstLedger,
    queryKey: "gst-ledger-report"
  });

  const { mutate: generatePeriodicSummary, isPending: isSummaryPending } = usePost({
    url: apiRoute.gstReport.GstPeriodicSummary,
    queryKey: "gst-periodic-summary"
  });

  const { mutate: generateGSTRegister, isPending: isGstRegisterPending } = usePost({
  url: apiRoute.gstReport.GstRegister,
  queryKey: "gst-register-report"
});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.fromDate || !formData.toDate) {
      toast.error("From Date and To Date are required");
      return;
    }

    if (formData.reportType === "GST Ledger") {
      const requestData = {
        CompCode: compCode,
        Bill_Type: formData.billType,
        FromDate: formData.fromDate,
        ToDate: formData.toDate,
      };
console.log(requestData)
      generateGSTReport(
        { data: requestData },
        {
          onSuccess: (data) => {
            navigate(linksUrl.gstReport.GstLedger, { 
              state: { 
                reportData: data,
                fromDate: formData.fromDate,
                toDate: formData.toDate
              } 
            });
            toast.success("GST Ledger report generated successfully");
          },
          onError: (error) => {
            toast.error("Failed to generate GST Ledger report: " + error.message);
          }
        }
      );
    } 
    else if (formData.reportType === "GST Summary Periodwise Report") {
      const requestData = {
        CompCode: compCode,
        FromDate: formData.fromDate,
        ToDate: formData.toDate,
        // Add any additional parameters needed for this report
        BillType: formData.billType,
        TradeType: formData.tradeType
      };

      generatePeriodicSummary(
        { data: requestData },
        {
          onSuccess: (data) => {
            navigate(linksUrl.gstReport.GstPeriodicSummary, { 
              state: { 
                reportData: data,
                fromDate: formData.fromDate,
                toDate: formData.toDate
              } 
            });
            toast.success("GST Summary Periodwise report generated successfully");
          },
          onError: (error) => {
            toast.error("Failed to generate GST Summary report: " + error.message);
          }
        }
      );
    }else if (formData.reportType === "GST Register") {
    const requestData = {
      CompCode: compCode,
      FromDate: formData.fromDate,
      ToDate: formData.toDate,
      BillType: formData.billType,
      // Add other optional parameters from your form
      TradeType: formData.tradeType,
      SupplyType: formData.supplyType,
      RvsChg: formData.reverseCharge === "ALL" ? -1 : formData.reverseCharge === "Reverse Charge" ? 1 : 0,
      GSTType: formData.gstType === "ALL" ? null : formData.gstType,
      GSTNature: formData.goodsNature === "ALL" ? null : formData.goodsNature,
      VouType: formData.voucherType || null,
      PCodeList: formData.partyCode || null,
      AccCodeList: formData.accountCode || null,
      StateList: formData.state || null
    };

    generateGSTRegister(
      { data: requestData },
      {
        onSuccess: (data) => {
          navigate(linksUrl.gstReport.GstRegister, { 
            state: { 
              reportData: data,
              fromDate: formData.fromDate,
              toDate: formData.toDate,
              filters: {
                billType: formData.billType,
                tradeType: formData.tradeType,
                // Include other relevant filters
              }
            } 
          });
          toast.success("GST Register report generated successfully");
        },
        onError: (error) => {
          toast.error("Failed to generate GST Register report: " + error.message);
        }
      }
    );
  }
  else {
    console.log('Form submitted:', formData);
    toast.info('Report generation for other types will be implemented soon');
  }
};

  const resetForm = () => {
    setFormData({
      reportType: '',
      tradeType: 'ALL',
      billType: 'ALL',
      supplyType: 'ALL',
      reverseCharge: 'ALL',
      gstType: 'ALL',
      goodsNature: 'ALL',
      partyCode: '',
      fromDate: '',
      toDate: '',
      voucherType: '',
      tradeOf: '',
      accountCode: '',
      state: ''
    });
  };

const isPending = isGstLedgerPending || isSummaryPending || isGstRegisterPending;

  return (
     <MainContainer
                pageName={`GST Report Generator`}
                info={[]}
                breadcrumbs={[" Reports And View ", "GST Report"]}
            >
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-1 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-md font-semibold mb-5 text-gray-800">Customize your GST report with advanced filters</h1>
        {/* Compact Header */}
        {/* <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center bg-white p-2 rounded-full shadow-md mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h1 className="text-xl font-bold text-gray-800">GST Report Generator</h1>
          <p className="mt-1 text-sm text-gray-600">Customize your GST report with advanced filters</p>
        </div> */}

        {/* Compact Form Card */}
        <div className="bg-white w-full rounded-lg shadow-xl overflow-hidden">
          <form onSubmit={handleSubmit} className="p-5 md:p-6">
            {/* Report Selection Section */}
            <div className="mb-6">
              <h2 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2 text-blue-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v3.586l-1.293-1.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V8z" clipRule="evenodd" />
                </svg>
                Report Selection
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-blue-50 p-3 rounded-md border border-blue-100">
                  <label className="block text-xs font-medium text-gray-700 mb-1">Report Type <span className="text-red-500">*</span></label>
                  <div className="relative">
                    <select
                      name="reportType"
                      value={formData.reportType}
                      onChange={handleChange}
                      required
                      className="block w-full pl-3 pr-8 py-2 text-sm border border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm appearance-none bg-white"
                    >
                      <option value="">Select a report type</option>
                      {reportTypes.map((type, index) => (
                        <option key={index} value={type}>{type}</option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-blue-700">
                      <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Date Range Section */}
            <div className="mb-6">
              <h2 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2 text-blue-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                </svg>
                Date Range
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-blue-50 p-3 rounded-md border border-blue-100">
                  <label className="block text-xs font-medium text-gray-700 mb-1">From Date <span className="text-red-500">*</span></label>
                  <div className="relative">
                    <input
                      type="date"
                      name="fromDate"
                      value={formData.fromDate}
                      onChange={handleChange}
                      required
                      className="block w-full pl-3 pr-8 py-2 text-sm border border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                    />
                    <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </div>
                  </div>
                </div>
                
                <div className="bg-blue-50 p-3 rounded-md border border-blue-100">
                  <label className="block text-xs font-medium text-gray-700 mb-1">To Date <span className="text-red-500">*</span></label>
                  <div className="relative">
                    <input
                      type="date"
                      name="toDate"
                      value={formData.toDate}
                      onChange={handleChange}
                      required
                      className="block w-full pl-3 pr-8 py-2 text-sm border border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                    />
                    <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Filter Sections */}
            <div className="mb-6">
              <h2 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2 text-blue-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clipRule="evenodd" />
                </svg>
                Report Filters
              </h2>
              
              {/* Row 1 */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div className="bg-blue-50 p-3 rounded-md border border-blue-100">
                  <label className="block text-xs font-medium text-gray-700 mb-1">Trade Type</label>
                  <div className="relative">
                    <select
                      name="tradeType"
                      value={formData.tradeType}
                      onChange={handleChange}
                      className="block w-full pl-3 pr-8 py-2 text-sm border border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm appearance-none bg-white"
                    >
                      {tradeTypes.map((type, index) => (
                        <option key={index} value={type}>{type}</option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-blue-700">
                      <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                </div>

                <div className="bg-blue-50 p-3 rounded-md border border-blue-100">
                  <label className="block text-xs font-medium text-gray-700 mb-1">Bill Type</label>
                  <div className="relative">
                    <select
                      name="billType"
                      value={formData.billType}
                      onChange={handleChange}
                      className="block w-full pl-3 pr-8 py-2 text-sm border border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm appearance-none bg-white"
                    >
                      {billTypes.map((type, index) => (
                        <option key={index} value={type.value}>{type.label}</option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-blue-700">
                      <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              {/* Row 2 */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div className="bg-blue-50 p-3 rounded-md border border-blue-100">
                  <label className="block text-xs font-medium text-gray-700 mb-1">Supply Type</label>
                  <div className="relative">
                    <select
                      name="supplyType"
                      value={formData.supplyType}
                      onChange={handleChange}
                      className="block w-full pl-3 pr-8 py-2 text-sm border border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm appearance-none bg-white"
                    >
                      {supplyTypes.map((type, index) => (
                        <option key={index} value={type}>{type}</option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-blue-700">
                      <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                </div>

                <div className="bg-blue-50 p-3 rounded-md border border-blue-100">
                  <label className="block text-xs font-medium text-gray-700 mb-1">Reverse Charge</label>
                  <div className="relative">
                    <select
                      name="reverseCharge"
                      value={formData.reverseCharge}
                      onChange={handleChange}
                      className="block w-full pl-3 pr-8 py-2 text-sm border border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm appearance-none bg-white"
                    >
                      {reverseCharges.map((type, index) => (
                        <option key={index} value={type}>{type}</option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-blue-700">
                      <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              {/* Row 3 */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-blue-50 p-3 rounded-md border border-blue-100">
                  <label className="block text-xs font-medium text-gray-700 mb-1">GST Type</label>
                  <div className="relative">
                    <select
                      name="gstType"
                      value={formData.gstType}
                      onChange={handleChange}
                      className="block w-full pl-3 pr-8 py-2 text-sm border border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm appearance-none bg-white"
                    >
                      {gstTypes.map((type, index) => (
                        <option key={index} value={type}>{type}</option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-blue-700">
                      <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                </div>

                <div className="bg-blue-50 p-3 rounded-md border border-blue-100">
                  <label className="block text-xs font-medium text-gray-700 mb-1">Goods Nature</label>
                  <div className="relative">
                    <select
                      name="goodsNature"
                      value={formData.goodsNature}
                      onChange={handleChange}
                      className="block w-full pl-3 pr-8 py-2 text-sm border border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm appearance-none bg-white"
                    >
                      {goodsNatures.map((type, index) => (
                        <option key={index} value={type}>{type}</option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-blue-700">
                      <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Additional Fields Section */}
            <div className="mb-6">
              <h2 className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2 text-blue-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
                </svg>
                Additional Parameters
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-blue-50 p-3 rounded-md border border-blue-100">
                  <label className="block text-xs font-medium text-gray-700 mb-1">Party Code</label>
                  <input
                    type="text"
                    name="partyCode"
                    value={formData.partyCode}
                    onChange={handleChange}
                    className="block w-full pl-3 pr-8 py-2 text-sm border border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                    placeholder="Enter party code"
                  />
                </div>

                <div className="bg-blue-50 p-3 rounded-md border border-blue-100">
                  <label className="block text-xs font-medium text-gray-700 mb-1">Voucher Type</label>
                  <input
                    type="text"
                    name="voucherType"
                    value={formData.voucherType}
                    onChange={handleChange}
                    className="block w-full pl-3 pr-8 py-2 text-sm border border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                    placeholder="Enter voucher type"
                  />
                </div>

                <div className="bg-blue-50 p-3 rounded-md border border-blue-100">
                  <label className="block text-xs font-medium text-gray-700 mb-1">Account Code</label>
                  <input
                    type="text"
                    name="accountCode"
                    value={formData.accountCode}
                    onChange={handleChange}
                    className="block w-full pl-3 pr-8 py-2 text-sm border border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                    placeholder="Enter account code"
                  />
                </div>

                <div className="bg-blue-50 p-3 rounded-md border border-blue-100">
                  <label className="block text-xs font-medium text-gray-700 mb-1">State</label>
                  <input
                    type="text"
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    className="block w-full pl-3 pr-8 py-2 text-sm border border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                    placeholder="Enter state"
                  />
                </div>
              </div>
            </div>

            {/* Form Actions */}
            <div className="flex flex-col sm:flex-row justify-between pt-5 border-t border-gray-200">
              <button
                type="button"
                onClick={resetForm}
                className="inline-flex items-center justify-center px-5 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mb-3 sm:mb-0"
              >
                Reset All Fields
              </button>
              <button
                type="submit"
                disabled={isPending}
                className="inline-flex items-center justify-center px-6 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
              >
                {isPending ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Generating...
                  </>
                ) : (
                  <>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                    Generate Report
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </MainContainer>
  );
};

export default GSTReportForm;